import { createSlice } from "@reduxjs/toolkit";
import { getPlayerTransactionThunk } from "../actions/player";

const initialState = {
  transaction: {} as any,
  status: "idle" as "idle" | "pending" | "success" | "error",
  error: undefined as string | any,
};

export const playerSlice = createSlice({
  name: "player",
  initialState,
  reducers: {
    clearTransaction: (state) => {
      state.transaction = {};
      state.status = "idle";
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPlayerTransactionThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(getPlayerTransactionThunk.fulfilled, (state, { payload }) => {
        state.transaction = payload;
        state.status = "success";
      })
      .addCase(getPlayerTransactionThunk.rejected, (state, { payload }) => {
        state.error = payload;
        state.status = "error";
      });
  },
});

export const { clearTransaction } = playerSlice.actions;
export default playerSlice.reducer;
